import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { map, Observable } from 'rxjs';
import { ChatClientService } from '../services/chat-client.service';

@Component({
  selector: 'app-chat-client-panel',
  templateUrl: './chat-client-panel.component.html',
  styleUrls: ['./chat-client-panel.component.scss'],
})
export class ChatClientPanelComponent {
  safeIframeUrl$: Observable<SafeResourceUrl | null>;

  constructor(
    public chatClientService: ChatClientService,
    sanitizer: DomSanitizer,
  ) {
    this.safeIframeUrl$ = this.chatClientService.iframeUrl$.pipe(
      map((url) =>
        url ? sanitizer.bypassSecurityTrustResourceUrl(url) : null,
      ),
    );
  }
}
